export default "__VITE_ASSET__BzoYpdPe__"